import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { formatDuration, getCourseLevelLabel, useTokens, useStore, } from '@mcn-platform/models';
import DocumentInfoBar from './DocumentInfoBar';
import MeetingInfoBar from './MeetingInfoBar';
const ItemInfo = ({ item, }) => {
    const { currentPortal } = useStore();
    const tokens = useTokens();
    const { courseCardShowLessonCount, } = currentPortal;
    if (!item) {
        return null;
    }
    if (item.isMeeting()) {
        return (_jsx(MeetingInfoBar, { meeting: item }));
    }
    if (item.isDocument()) {
        return (_jsx(DocumentInfoBar, { document: item }));
    }
    let itemCountText = '';
    if (item.isCourse() && item.format !== 'scorm12') {
        itemCountText = (courseCardShowLessonCount === undefined || courseCardShowLessonCount)
            ? `${item.lessonCount} ${tokens.getToken('lessonName/plural')}`
            : '';
    }
    if (item.isProgram()) {
        itemCountText = `${item?.calcCourseCount(true)} ${tokens.getToken('courseName/plural')}`;
    }
    if (item.isMicrocast()) {
        itemCountText = tokens.getToken('microcastName');
    }
    const durationItem = item.microcastAsset || item;
    const infoItems = [
        formatDuration(durationItem?.length),
        itemCountText,
        getCourseLevelLabel(item.level),
    ].filter(Boolean);
    return (_jsx(Stack, { direction: "row", divider: _jsx(Divider, { orientation: "vertical", flexItem: true }), sx: { marginY: 'auto', width: 1 }, justifyContent: "space-between", alignItems: "center", children: infoItems.map((text, index) => (_jsx(Typography
        // eslint-disable-next-line react/no-array-index-key
        , { component: "div", className: "courseDisplayCourseInfoBarText", sx: { maxWidth: 0.33 }, children: text }, index))) }));
};
export default observer(ItemInfo);
//# sourceMappingURL=ItemInfo.js.map